export const isNativeAuthSupported = async (): Promise<boolean> => {
  const webAuthnSupported = Boolean(window?.PublicKeyCredential);

  if (!webAuthnSupported) {
    return false;
  }

  const platformAuthenticatorAvailable =
    await PublicKeyCredential.isUserVerifyingPlatformAuthenticatorAvailable().catch(
      () => false
    );

  return platformAuthenticatorAvailable;
};

export const hasDeniedPermissions = (error: any) =>
  error instanceof DOMException &&
  (error as DOMException).name === 'NotAllowedError';
